
import Vue from 'vue'

var components= {
    CreditApplication: Vue.component('CreditApplication',require('../components/CreditApplication/CreditApplication.vue').default),
    RentalPickup: Vue.component('RentalPickup',require('../components/RentalPickup/RentalPickup.vue').default),
    WholesaleQuote: Vue.component('WholesaleQuote',require('../components/WholesaleQuote/WholesaleQuote.vue').default),
    Contact: Vue.component('Contact',require('../components/contact/contact.vue').default),
    Delivery: Vue.component('Delivery',require('../components/Delivery/Delivery.vue').default),
    RentalDelivery: Vue.component('RentalDelivery',require('../components/RentalDelivery/RentalDelivery.vue').default),
    DeliveryDateConfirmation: Vue.component('DeliveryDateConfirmation',require('../components/DeliveryDateConfirmation/DeliveryDateConfirmation.vue').default),
    CustomerPickup: Vue.component('CustomerPickup',require('../components/CustomerPickup/CustomerPickup.vue').default),
    RailboxContact: Vue.component('RailboxContact',require('../components/RailboxContact/RailboxContact.vue').default),
  }

export default [
  {
    path: '/RentalPickup',
    name: 'rental-pickup',
    component: components.RentalPickup
  },
  {
    path: '/CreditApplication',
    name: 'credit-application',
    component: components.CreditApplication
  },
  {
    path: '/WholesaleQuote',
    name: 'wholesale-quote',
    component:components.WholesaleQuote
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: components.Contact
  },
  {
    path: '/Delivery',
    name: 'Delivery',
    component: components.Delivery
  },
  {
    path: '/RentalDelivery',
    name: 'RentalDelivery',
    component: components.RentalDelivery
  },
  {
    path: '/DeliveryDateConfirmation',
    name: 'DeliveryDateConfirmation',
    component: components.DeliveryDateConfirmation
  },
  {
    path: '/CustomerPickup',
    name: 'CustomerPickup',
    component: components.CustomerPickup
  },
  {
    path: '/RailboxContact',
    name: 'RailboxContact',
    component: components.RailboxContact
  }
]